import { ReactComponent } from './number-4-xl.svg';
export const Number4IconXl = ReactComponent;
export default ReactComponent;

//# sourceMappingURL=number-4-xl.js.map